import { Check, Heart, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { services } from '../data/mock';

const BoudoirPhotography = () => {
  const boudoirService = services[2];

  return (
    <div className="bg-black text-white min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 rounded-full bg-red-600/10 flex items-center justify-center">
              <Heart className="text-red-500" size={36} />
            </div>
          </div>
          <h1 className="font-display text-5xl md:text-6xl font-bold text-red-500 mb-6 uppercase">
            Boudoir & Intimate Photography
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed">
            {boudoirService.description}
          </p>
        </div>

        {/* Features */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Our Approach</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="flex items-start gap-4 bg-zinc-900 rounded-lg p-6 border border-red-900/20">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600/10 flex items-center justify-center">
                <Check className="text-red-500" size={20} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Private, Discreet Sessions</h3>
                <p className="text-gray-400 text-sm">Complete confidentiality with secure, controlled access to the studio. Your session remains private with no unexpected interruptions or external access.</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-zinc-900 rounded-lg p-6 border border-red-900/20">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600/10 flex items-center justify-center">
                <Check className="text-red-500" size={20} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Soft, Flattering Lighting Setups</h3>
                <p className="text-gray-400 text-sm">Professional lighting designed specifically for intimate photography - creating soft shadows, highlighting natural beauty, and ensuring the most flattering results.</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-zinc-900 rounded-lg p-6 border border-red-900/20">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600/10 flex items-center justify-center">
                <Check className="text-red-500" size={20} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Editorial Boudoir Styling</h3>
                <p className="text-gray-400 text-sm">High-fashion approach to intimate photography with artistic composition, sophisticated poses, and editorial-quality results that feel timeless and empowering.</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-zinc-900 rounded-lg p-6 border border-red-900/20">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600/10 flex items-center justify-center">
                <Check className="text-red-500" size={20} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Body-Positive Atmosphere</h3>
                <p className="text-gray-400 text-sm">We celebrate all body types and create a comfortable, judgment-free environment where you can express yourself authentically and feel beautiful throughout your session.</p>
              </div>
            </div>

            <div className="flex items-start gap-4 bg-zinc-900 rounded-lg p-6 border border-red-900/20">
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-600/10 flex items-center justify-center">
                <Check className="text-red-500" size={20} />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-white mb-2">Professional Respect & Boundaries</h3>
                <p className="text-gray-400 text-sm">Clear communication, established boundaries, and unwavering respect for your comfort level at every stage. Your experience is guided by professional standards and consent-first principles.</p>
              </div>
            </div>
          </div>
        </div>

        {/* Empowerment Section */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Empowerment Through Art</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Body Positive Environment</h3>
              <p className="text-gray-400 leading-relaxed">
                We celebrate all bodies and create a comfortable, empowering atmosphere where you can express your authentic self with confidence.
              </p>
            </div>
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Professional Respect</h3>
              <p className="text-gray-400 leading-relaxed">
                Every session maintains the highest standards of professionalism, with clear boundaries and absolute respect for your comfort level.
              </p>
            </div>
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Editorial Quality</h3>
              <p className="text-gray-400 leading-relaxed">
                Our boudoir work is artistic and editorial in style, creating timeless images with sophisticated lighting and composition.
              </p>
            </div>
            <div className="bg-zinc-900 rounded-lg p-8 border border-red-900/20">
              <h3 className="text-xl font-semibold text-red-500 mb-4">Complete Privacy</h3>
              <p className="text-gray-400 leading-relaxed">
                Your session is private and confidential. We ensure discretion and controlled access throughout your experience.
              </p>
            </div>
          </div>
        </div>

        {/* Safety & Consent */}
        <div className="max-w-4xl mx-auto mb-20">
          <div className="bg-zinc-900 rounded-lg p-8 lg:p-12 border border-red-900/20">
            <div className="flex justify-center mb-6">
              <div className="w-16 h-16 rounded-full bg-red-600/10 flex items-center justify-center">
                <Shield className="text-red-500" size={32} />
              </div>
            </div>
            <h2 className="text-3xl font-semibold text-white mb-6 text-center">Consent & Safety First</h2>
            <p className="text-lg text-gray-300 leading-relaxed mb-6">
              Before every session, we discuss boundaries, comfort levels, and creative direction. You have complete control over the session, and can pause or stop at any time. Professional conduct is non-negotiable.
            </p>
            <ul className="text-gray-400 space-y-3">
              <li className="flex items-start gap-3">
                <Check className="text-red-500 flex-shrink-0 mt-1" size={20} />
                <span>Clear communication about boundaries and expectations</span>
              </li>
              <li className="flex items-start gap-3">
                <Check className="text-red-500 flex-shrink-0 mt-1" size={20} />
                <span>Professional photographer with extensive experience</span>
              </li>
              <li className="flex items-start gap-3">
                <Check className="text-red-500 flex-shrink-0 mt-1" size={20} />
                <span>Option to bring a trusted companion to your session</span>
              </li>
              <li className="flex items-start gap-3">
                <Check className="text-red-500 flex-shrink-0 mt-1" size={20} />
                <span>Complete control over image usage and distribution</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Featured Image */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Featured Work</h2>
          <img 
            src="https://images.unsplash.com/photo-1760460432096-26b25eb34a18?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxib3Vkb2lyJTIwcGhvdG9ncmFwaHklMjBlbGVnYW50JTIwd29tYW58ZW58MHx8fHwxNzcxNTI0NDA2fDA&ixlib=rb-4.1.0&q=85" 
            alt="Professional boudoir lingerie photography"
            className="w-full h-auto object-cover rounded-lg"
          />
        </div>

        {/* Gallery */}
        <div className="max-w-6xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Portfolio Preview</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_cinema-studio-3/artifacts/1sug6rvm_Black-Lace-Sexy-Couples-Boudoir-Session-Roseville-Boudoir-Photographer-by-Carmen-Salazar-Photography-8-480x721.webp" 
              alt="Black lace couples boudoir session"
              className="w-full h-80 object-cover rounded-lg"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_cinema-studio-3/artifacts/65gpjjed_Screenshot%202025-08-03%20173952.png" 
              alt="Intimate couples photography"
              className="w-full h-80 object-cover rounded-lg"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_cinema-studio-3/artifacts/4v5ka4jz_Screenshot%202025-08-03%20174054.png" 
              alt="Sensual boudoir lingerie"
              className="w-full h-80 object-cover rounded-lg"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_cinema-studio-3/artifacts/49ssjnyo_Sexy-intimate-Couples-Boudoir-Session-Roseville-Boudoir-Photographer-by-Carmen-Salazar-Photography-11-480x320.webp" 
              alt="Intimate couples against brick wall"
              className="w-full h-80 object-cover rounded-lg"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_cinema-studio-3/artifacts/ykeu7vch_093_1-480x719.webp" 
              alt="Artistic boudoir portrait"
              className="w-full h-80 object-cover rounded-lg"
            />
          </div>
          <p className="text-center text-gray-500 text-sm mt-6 italic">
            All images shown with full consent. Your privacy is our priority.
          </p>
        </div>

        {/* Pricing */}
        <div className="max-w-4xl mx-auto mb-20">
          <h2 className="text-3xl font-semibold text-white mb-8 text-center">Session Packages</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {boudoirService.pricing.map((pkg, index) => (
              <div 
                key={index} 
                className="bg-zinc-900 rounded-lg p-8 border border-red-900/20 hover:border-red-600/50 transition-all text-center"
              >
                <h3 className="text-xl font-semibold text-white mb-2">{pkg.package}</h3>
                <p className="text-4xl font-bold text-red-500 my-6">{pkg.price}</p>
                <Link 
                  to="/contact"
                  className="block w-full bg-red-600 hover:bg-red-700 text-white py-3 rounded-full font-mono text-sm tracking-widest uppercase transition-all"
                >
                  Book Session
                </Link>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <h2 className="text-3xl font-semibold text-white mb-4">Ready to Begin?</h2>
          <p className="text-gray-400 mb-8">Let's create empowering, artistic images together</p>
          <Link 
            to="/contact"
            className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-full font-mono text-sm tracking-widest uppercase transition-all"
          >
            Get in Touch
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BoudoirPhotography;
